module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.editMode || !_vm.channel.is_hidden) ? _c('li', {
    staticClass: "channel",
    class: {
      'dim': _vm.editMode && _vm.channel.is_hidden
    },
    attrs: {
      "id": _vm.channelGroupId,
      "data-cid": _vm.channel.id
    }
  }, [(!_vm.channel.is_protected && !_vm.editMode) ? _c('div', [(_vm.channel.is_favorite) ? _c('div', {
    staticClass: "channel_favorite-icon active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": "Удалить из избранного"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeFromFavorites(_vm.channel)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "dist/star-active.svg"
    }
  })])]) : _c('div', {
    staticClass: "channel_favorite-icon"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "title": "Добавить в избранное"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addToFavorites(_vm.channel)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "dist/star.svg"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "channel_body",
    class: {
      'disabled': _vm.editMode
    },
    on: {
      "click": _vm.openChannel
    }
  }, [_c('div', {
    staticClass: "channel_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.channel.icon
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "channel_info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.channel.name))]), _vm._v(" "), _c('div', {
    staticClass: "programm",
    attrs: {
      "title": _vm.channel.epg_progname
    }
  }, [_vm._v(_vm._s(_vm.channel.epg_progname))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel.epg_start),
      expression: "channel.epg_start"
    }],
    staticClass: "time"
  }, [_c('div', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.channel.epg_start)))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    style: ({
      'width': _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.channel.epg_end)))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel.archive && !_vm.editMode),
      expression: "channel.archive && !editMode"
    }],
    staticClass: "channel_right-button",
    attrs: {
      "title": "Открыть архив"
    },
    on: {
      "click": _vm.showEpg
    }
  }, [_c('i', {
    staticClass: "icon-clock"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode && !_vm.channel.is_hidden),
      expression: "editMode && !channel.is_hidden"
    }],
    staticClass: "channel_right-button hide-channel-button",
    attrs: {
      "title": "Скрыть канал"
    },
    on: {
      "click": function($event) {
        return _vm.hideChannel(_vm.channel)
      }
    }
  }, [_c('i', {
    staticClass: "icon-eye"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode && _vm.channel.is_hidden),
      expression: "editMode && channel.is_hidden"
    }],
    staticClass: "channel_right-button show-channel-button",
    attrs: {
      "title": "Показывать канал"
    },
    on: {
      "click": function($event) {
        return _vm.showChannel(_vm.channel)
      }
    }
  }, [_c('i', {
    staticClass: "icon-eye"
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-262705c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Channel.vue
// module id = 89
// module chunks = 0